import { DEFAULT_GEO_RANGE } from '@/constants/numbers';
import {
  EffectWithNotification,
  notificationShowAction
} from '@/features/notifications/notificationsContext';
import { fetchPlaces } from '@/features/places/api';
import {
  placesAdd,
  placesFetch,
  placesFetchFailed,
  placesFetchMore,
  placesSet
} from '@/features/places/state/actions';
import { PlacesAction, PlacesState } from '@/features/places/state/context';
import { PlacesReqParamsQuery } from '@/features/places/types/places.dto';
import { listingTranslate } from '@/i18n/translations/listingTranslations';
import { getResponseJSON } from '@/lib/checkResponse';

export const fetchPlacesEffect = async ({
  state,
  dispatch,
  notificationDispatch
}: EffectWithNotification<PlacesState, PlacesAction>) => {
  try {
    // ? always start from the beginning if query changed
    const queryParams: PlacesReqParamsQuery = {
      rangeForm: 0,
      rangeTo: DEFAULT_GEO_RANGE
    } as PlacesReqParamsQuery;

    if (state.snapshot?.action.type === placesFetch.type) {
      const {
        payload: { query }
      } = state.snapshot?.action;

      queryParams['query'] = query;
    }

    if (state.snapshot?.action.type === placesFetchMore.type) {
      queryParams['query'] = state.query;
      queryParams['rangeForm'] = state.rangeTo;
      queryParams['rangeTo'] = state.rangeTo + DEFAULT_GEO_RANGE;
    }

    const placesResponse = await getResponseJSON(
      await fetchPlaces({
        ...queryParams
      })
    );

    state.snapshot?.action.type === placesFetch.type
      ? dispatch(
          placesSet({
            ...placesResponse
          })
        )
      : dispatch(
          placesAdd({
            ...placesResponse,
            // ? set prev max range
            rangeFrom: queryParams.rangeForm as number,
            rangeTo: queryParams.rangeTo as number
          })
        );
  } catch (err) {
    dispatch(placesFetchFailed({ error: err as Error }));
    notificationDispatch(
      notificationShowAction({
        severity: 'warning',
        title: listingTranslate('places.fetch.failed'),
        ttl: 3000
      })
    );
  }
};
